import React from "react";
import { useTranslation } from "../../../../context/Internationalization";
import SkeletonRow from "../../../../Components/SkeletonRow";
import Table from "../../../../Components/Table/Table";
import ClubsTableRow from "./ClubsTableRow";
import { createEmptyData } from "../../../../utility/Utils";

const schema = (t) => [
  {
    id: "name",
    label: t("club_name"),
  },
  {
    id: "color",
    label: t("club_color"),
  },
  {
    id: "country",
    label: t("country"),
  },
  {
    id: "founded",
    label: t("founded"),
  },
  {
    id: "website",
    label: t("contact_info"),
  },
  {
    id: "field",
    label: t("field_info"),
  },
  {
    id: "location",
    label: t("location"),
  },
  {
    id: "isClaimed",
    label: t("isClaimed"),
  },
  {
    id: "actions",
    label: "",
  },
];

const ClubsTable = ({ clubs, menuActions, lastElementRef, loading }) => {
  const { t } = useTranslation();

  const rowElement = (club, index) => {
    if (club.skeleton) {
      return (
        <SkeletonRow
          key={index}
          rowKey={index}
          columnsCount={schema(t).length}
        />
      );
    }
    return (
      <ClubsTableRow
        key={club._id}
        lastElementRef={lastElementRef}
        club={club}
        index={index}
        menuActions={menuActions}
      />
    );
  };

  const rows = loading ? [...clubs, ...createEmptyData()] : clubs;

  return <Table rows={rows} columns={schema(t)} rowElement={rowElement} />;
};

export default ClubsTable;
